import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Nasenpflaster',
    desc: 'Hilft nicht. Also "liegt\'s nicht an der Nase", denkst du.',
    delay: 0.1
  }, {
    title: 'Seitlich schlafen',
    desc: 'Wachst um 03:20 Uhr auf dem Rücken auf. Natürlich.',
    delay: 0.2
  }, {
    title: 'Allgemeine Schlaftipps',
    desc: 'Fühlst dich kurz motiviert — bis das echte Leben kommt.',
    delay: 0.3
  }];
  return <section className="w-full bg-[#0f172a] py-20 px-4 md:px-6" data-id="element-33">
      <div className="max-w-2xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-[#faf5ef] mb-6" data-id="element-36">
            Was die meisten Männer dann tun
          </h2>
          <p className="text-lg text-[#94a3b8]" data-id="element-37">
            Sie kaufen Tools. Und ja — Tools können helfen. Aber wenn du sie
            ohne System kaufst, passiert das hier:
          </p>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-38">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: item.delay,
          duration: 0.5
        }} className="flex items-start p-5 bg-[#1e293b] rounded-xl border border-[#334155] relative overflow-hidden group" data-id="element-39">
              <div className="absolute inset-0 bg-red-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-40"></div>
              <div className="flex-shrink-0 mr-4 mt-1 bg-red-500/10 p-2 rounded-full" data-id="element-41">
                <X className="w-5 h-5 text-red-400" data-id="element-42" />
              </div>
              <div data-id="element-43">
                <h3 className="text-lg font-bold text-[#cbd5e1] line-through decoration-red-400/50 decoration-2" data-id="element-44">
                  {item.title}
                </h3>
                <p className="text-[#94a3b8] mt-1" data-id="element-45">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center p-8 bg-[#1e293b]/50 rounded-2xl border border-[#d4a574]/20" data-id="element-46">
          <p className="text-xl md:text-2xl font-bold text-[#d4a574]" data-id="element-47">
            Das ist kein Charakterproblem.
            <br data-id="element-48" />
            Das ist ein Diagnoseproblem.
          </p>
        </motion.div>
      </div>
    </section>;
}